var _ = require('underscore');

var TorsoFormModel = require('backbone-torso/modules/FormModel');

var numberUtils = require('./../../utils/numberUtils');

var TO_SERVER_COLUMN_DIRECTION_MAP = {
  ASC: true,
  DESC: false,
  NONE: undefined
};

/**
 * Cell containing the shared state and logic of the Concierge worklist.
 *
 * @class ConciergeWorklistTableState
 * @constructor
 */
var TableState = TorsoFormModel.extend({
  TO_SERVER_COLUMN_DIRECTION_MAP: TO_SERVER_COLUMN_DIRECTION_MAP,

  /**
   * Creates a paging and sorting object from this view's state that matches the PagingAndSorting object used on the server.
   * @method checkValidation
   * @param {String} The property on tablestate that we want to validate
   * @return {object} Returns an object is validation fails.
   */
  checkValidation: function(property) {
    return this.preValidate(property);
  },

  /**
   * Creates a paging and sorting object from this view's state that matches the PagingAndSorting object used on the server.
   * @method getPagingAndSorting
   * @return {Object} a paging and sorting object with pageNumber, pageSize and any sorting info.
   */
  getPagingAndSorting: function() {
    var entriesPerPage = this.get('entriesPerPage');
    entriesPerPage = numberUtils.convertToNumberWithMinimum(entriesPerPage, 1);

    var widgetPageNumber = this.get('page');
    var serverPageNumber = numberUtils.convertOneToZeroBased(widgetPageNumber);

    var pagingAndSorting = {
      pageNumber: serverPageNumber,
      pageSize: entriesPerPage
    };

    var columnSorting = this.get('columnSorting');
    if (!_.isEmpty(columnSorting)) {
      var serverOrderingMap = {};
      _.each(columnSorting, function(direction, clientSortingColumnPropertyName) {
        var serverDirection = TO_SERVER_COLUMN_DIRECTION_MAP[direction];
        if (!_.isUndefined(serverDirection)) {
          var serverProperty = this._getServerColumnSortingPropertyName(clientSortingColumnPropertyName);
          serverOrderingMap[serverProperty] = serverDirection;
        }
      }, this);
      if (!_.isEmpty(serverOrderingMap)) {
        pagingAndSorting.orderingMap = serverOrderingMap;
      }
    }

    return pagingAndSorting;
  },

  /**
   * @method _getServerColumnSortingPropertyName
   * @param clientColumnName {String} the column name used by this widget.
   * @return {String} the column name used on the server for sorting.
   * @private
   */
  _getServerColumnSortingPropertyName: function(clientColumnName) {
    return clientColumnName;
  }
});

TableState.TO_SERVER_COLUMN_DIRECTION_MAP = TO_SERVER_COLUMN_DIRECTION_MAP;

module.exports = TableState;
